import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";

const EditEventPage = () => {
  const { id } = useParams(); // Pobieramy ID wydarzenia z URL
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    location: "",
    date: "",
    status: "Planned",
  });
  const [error, setError] = useState(null);

  // Pobieranie szczegółów wydarzenia
  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const response = await api.get(`/Events/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const { title, description, location, date, status } = response.data;
  
        // Ustawiamy wszystkie pola, w tym id
        setFormData({ id, title, description, location, date, status });
      } catch (err) {
        console.error(err);
        setError("Failed to fetch event details.");
      }
    };
    fetchEvent();
  }, [id]);
  

  // Obsługa zmiany danych formularza
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Aktualizacja wydarzenia
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedData = {
        ...formData,
        id, // Dodajemy id do przesyłanego obiektu
        date: new Date(formData.date).toISOString(), // Konwersja daty do ISO
      };
  
      console.log("Sending data to API:", updatedData); // Debugowanie
  
      await api.put(`/Events/${id}`, updatedData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
  
      alert("Event updated successfully!");
      navigate(`/events/${id}`); // Przekierowanie do szczegółów wydarzenia
    } catch (err) {
      console.error("Error while updating event:", err.response?.data || err.message);
      if (err.response && err.response.data) {
        alert(`Failed to update event: ${err.response.data.message}`);
      } else {
        alert("Failed to update event. Please try again.");
      }
    }
  };
  
  if (error) {
    return <div>{error}</div>;
  }

  if (!formData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Edit Event</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 mb-2">Title:</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 mb-2">Description:</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 mb-2">Location:</label>
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 mb-2">Date:</label>
          <input
            type="datetime-local"
            name="date"
            value={formData.date}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 mb-2">Status:</label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
          >
            <option value="Planned">Planned</option>
            <option value="InProgress">In Progress</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>
        <button
          type="submit"
          className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
        >
          Save Changes
        </button>
      </form>
    </div>
  );
};

export default EditEventPage;
